import Nullstack from 'nullstack';
export default function IconKering({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-kering",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M16 15v-3.5a2.5 2.5 0 1 1 5 0v3.5m0 -2h-5"
  }), "   ", Nullstack.element("path", {
    d: "M3 9l3 6l3 -6"
  }), "   ", Nullstack.element("path", {
    d: "M9 20l6 -16"
  }), " ");
}